export const dataMembershipTypes = {
    loading: "[dataMembership] loading",
    partialLoad: "[dataMembership] partialLoad",
    load: "[dataMembership] load",
    addYear: "[dataMembership] addYear",
    reload: "[dataMembership] reload",
    error: "[dataMembership] error",
    clean: "[dataMembership] clean",
};
